"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./TabHeading.scss");
var TabHeading = function (_a) {
    var dusk = _a.dusk, label = _a.label, content = _a.content;
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: "tab-heading" },
        label,
        react_1.default.createElement("div", { className: "tab-heading__content" }, content)));
};
exports.default = TabHeading;
//# sourceMappingURL=index.js.map